/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FALFacility } from '../../models/fal-facility';
import { mergeMap as _observableMergeMap, catchError as _observableCatch, map, retry } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { ErrorResponse, LocationDetailResponse } from '../nswag/locations.service';
import { InstanceService } from '@commonspirit/ngx-instance';
import { ConfigurationKey } from 'src/app/core/models/configuration-key';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
  public listLocations:FALFacility[] | undefined;
  constructor(private http: HttpClient, private instanceService: InstanceService) {}

  load(): Observable<FALFacility[]> {
    return this.http.get<any>('../../../assets/facilities.json').pipe(
      map(({ data }): FALFacility[] => {
        this.listLocations=data;
        return data;
      })
    );
  }

  details(id: number): Observable<LocationDetailResponse> {
    //let url_ = this.baseUrl + '/details/{id}';
    let url_ = '../../../../assets/locations.json';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          debugger
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDetails(response_);
            } catch (e) {
              return <Observable<LocationDetailResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<LocationDetailResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDetails(response: HttpResponseBase): Observable<LocationDetailResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    const _headers: any = {};
    if (response.headers) {
      for (const key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          const resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LocationDetailResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          const resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          const resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ErrorResponse.fromJS(resultData404);
          return throwException('Resource Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<LocationDetailResponse>(<any>null);
  }

  public loadXF(externalCode: string): Observable<string> {
    const options = { responseType: 'text' as const };
    console.log(window.location.origin.toLocaleLowerCase());
    const vmfhBaseUrl = this.instanceService.getConfiguration(ConfigurationKey.VmfhBaseUrl)?.value as { link: string };
    if(window.location.origin.toLocaleLowerCase().includes('http://localhost')) vmfhBaseUrl.link = 'https://vmfhorg.cshcontentdev.org'
    const contentUrl = this.instanceService.getConfiguration(ConfigurationKey.NavigationContentUrl)?.value as { link: string };
    const vmfhContentUrl = `${vmfhBaseUrl.link}${contentUrl.link}`;
    return this.http.get(vmfhContentUrl.replace(/{{externalCode}}/g, externalCode), options).pipe(retry(2));
  }
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
      super();

      this.message = message;
      this.status = status;
      this.response = response;
      this.headers = headers;
      this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
      return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
      return _observableThrow(result);
  else
      return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
      if (!blob) {
          observer.next("");
          observer.complete();
      } else {
          let reader = new FileReader();
          reader.onload = event => {
              observer.next((<any>event.target).result);
              observer.complete();
          };
          reader.readAsText(blob);
      }
  });
}
